/* eslint-disable array-callback-return */
import { Component } from "react";
import { Link } from "react-router-dom";
import { imsLoader} from "../../assets";
import ApiServices from "../../utils/apiServices";
import trackingService from "../../services/trackingService";
import "../ContentShortcuts/ContentShortcuts.css";

class KeyCongressLitGenAIRec extends Component {
  constructor(props) {
    super(props);
    this.service = new ApiServices();
    this.state = {
      showCSModal: false,
      products: props.products,
      selectedProduct: props.selectedProduct,
      congressNames: [],
      showInfo: false,
      startIndex: 0,
      isSelectedProduct: false,
      isLoaded: false,
    };
  }
  async componentDidMount() {
    if (
      this.props.products?.length > 0 &&
      this.props.selectedProduct.length > 0
    ) {
      this.setState(
        {
          products: this.props.products,
          selectedProduct: this.props.selectedProduct,
        },
        async () => {
          let congressName = await this.service.getCongressforProduct(
            this.state.selectedProduct
          );
          if (congressName?.length > 0) {
            this.setState({ congressNames: congressName }, () => {
              setTimeout(() => {
                this.setState({ isLoaded: true })
              }, 1500);

            });
          }
        }
      );
    }
  }
  componentWillReceiveProps() {
    if (this.props.products?.length !== this.state.products.length) {
      if (
        this.props.products?.length > 0 &&
        this.props.selectedProduct.length > 0
      ) {
        this.setState(
          {
            products: this.props.products,
            selectedProduct: this.props.selectedProduct,
          },
          async () => {
            let congressName = await this.service.getCongressforProduct(
              this.state.selectedProduct
            );
            if (congressName?.length > 0) {
              this.setState({ congressNames: congressName });
            }
          }
        );
      }
    }
  }
  componentDidUpdate = () => {
    if (this.props.showKCLCSModal !== this.state.showCSModal) {
      this.setState({ showCSModal: this.props.showKCLCSModal });
    }
  };
  productOptionListing = () => {
    let { products } = this.state
    return (
      <>
        {(products && products.length > 0) && products.map((item, index) => {
          return (
            <option
              key={index}
              id={`${item}`}
            >
              {item}
            </option>
          );
        })}
      </>
    )
  }
  handleSelectProduct = (event) => {
    event.preventDefault();
    if (event) {
      this.setState(
        {
          selectedProduct: event.target.innerText,
          isSelectedProduct: false
        },
        async () => {
          let congressName = await this.service.getCongressforProduct(
            this.state.selectedProduct
          );
          this.setState({ congressNames: congressName });
        }
      );
    }
  };

  generateListOfCongressNames = (arrayOfCogName) => {
    if (arrayOfCogName.length > 0) {
      return arrayOfCogName.map((items, index) => {
        let url;
        if (this.state.selectedProduct !== "") {
          url = `/results?query=${this.state.selectedProduct}&q=All%20Fields&filters=${items.congresspath};Document Type/Medical Literature/Abstracts;Document Type/Medical Literature/Oral Presentations;Document Type/Medical Literature/Posters;Publication Year/2023;Publication Year/2022&f1=tempJNJDrugs&fval1=${this.state.selectedProduct}&fcount=1&cspath=Key Congress Literature Documents-${items.congressname}&csproduct=${this.state.selectedProduct}`;
        } else {
          url =
            `/results?query=${this.state.selectedProduct}&q=All%20Fields&filters=` +
            items.filter;
        }
        return (
          <li key={index} className="modal-list-genAI">
            <Link
              to={url}
              target="_blank"
              className="cs-modalLink"
              onClick={() =>
                this.handelCongressDocsTypesLinks(
                  items.congresspath,
                  items.congressname
                )
              }
            >
              <span className="modal-list-genAI-a-span">{items.congressname}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </Link>
          </li>
        );
      });
    }
  };
  generateCongressHoldingPages = () => {
    let url;
    if (this.state.selectedProduct !== "") {
      url = `/results?query=${this.state.selectedProduct}&q=All%20Fields&filters=Document Type/Medical Literature Compilations/SKM EMEA Highlighted Data&f1=tempJNJDrugs&fval1=${this.state.selectedProduct}&f2=docTitle&fval2=Holding AND (Page OR Poster OR Posters)&fcount=2&cspath=Key Congress Literature Documents-Congress Holding Pages (collections of congress materials from key congresses)&csproduct=${this.state.selectedProduct}`;
    } else {
      url = `/results?query=${this.state.selectedProduct}&q=All%20Fields&filters=Document Type/Medical Literature Compilations/SKM EMEA Highlighted Data`;
    }
    return (
      <li className="modal-list-genAI">
        <Link
          to={url}
          target="_blank"
          className="cs-modalLink"
          onClick={this.handelDocsTypesLinks}
        ><span className="modal-list-genAI-a-span">
            Congress Holding Pages (collections of congress materials from key
            congresses)</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </Link>
      </li>
    );
  };
  handelCongressDocsTypesLinks = (congresspath, title) => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      // "Link visited from Key Congress Literature Documents tile",
      `Visited ${this.state.selectedProduct} for ${title}`,
      "",
      window.location.href,
      this.state.selectedProduct,
      `${congresspath};Document Type/Medical Literature/Abstracts;Document Type/Medical Literature/Oral Presentations;Document Type/Medical Literature/Posters;Publication Year/2023;Publication Year/2022`,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      `Key Congress Literature Documents-${title}`,
      this.state.selectedProduct
    );
  };
  handelDocsTypesLinks = () => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      // "Link visited from Key Congress Literature Documents tile",
      `Visited ${this.state.selectedProduct} for Congress Holding Pages (collections of congress materials from key congresses)`,
      "",
      window.location.href,
      this.state.selectedProduct,
      "Document Type/Medical Literature Compilations/SKM EMEA Highlighted Data",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Key Congress Literature Documents-Congress Holding Pages (collections of congress materials from key congresses)",
      this.state.selectedProduct
    );
  };

  handleCloseModal = () => {
    this.setState({ showCSModal: false }, () => {
      this.props.handelKCLCardDetail(this.state.showCSModal);
    });
  };
  render() {
    return (
      <div className="GenAI-Recomm-ContentShortcutInnerWapper">

        {this.state.showCSModal && (
          <>
            <div
              className="gen-ai-cs-modalHeader"
              style={{
                justifyContent: "center",
                display: this.state.products.length <= 0 && "none",
              }}
            >
              <select name="gen-ai-cs-product" id="gen-ai-cs-product" className="select-category popoverAvoidClickOutside" value={this.state.selectedProduct} onChange={(e) => {
                this.setState(
                  {
                    selectedProduct: e.target.value
                  });

              }}>
                {
                  this.productOptionListing()
                }
              </select>
              <div className="gen-ai-cs-popup-cancel-btn popoverAvoidClickOutside">
                <span className="popoverAvoidClickOutside" onClick={this.handleCloseModal}>
                  <svg width="18px" height="18px" className="popoverAvoidClickOutside" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier"> <title>cancel</title> <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                      <g id="work-case" fill="#afa7a7" transform="translate(91.520000, 91.520000)">
                        <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"> </polygon> </g> </g> </g></svg>
                </span>
              </div>
            </div>
            {this.state.isLoaded ? <div
              className="modal-body-height-genAI"
              style={{ width: this.state.products.length <= 0 && "95%", opacity: this.state.isSelectedProduct && '0.4' }}
            >
              {/* <div>
                {this.state.congressNames.length > 0 &&
                  this.state.products.length > 0 && (
                    <p class="congressText">
                      The following have been selected as the major
                      congresses for the chosen product for the Publication
                      Year 2022 - 2023. For a complete list of congresses
                      for all years, please use the <b>Congress Names</b>{" "}
                      filter.
                    </p>
                  )}
              </div> */}
              <div className="cs-modalList gen-ai-cs-modalList">
                <ul style={{ listStyle: "none" }}>
                  {this.generateListOfCongressNames(
                    this.state.congressNames
                  )}
                  {this.generateCongressHoldingPages()}
                </ul>
              </div>
            </div> : <div style={{ textAlign: "center", padding: "10%", background: "#fff" }}>
              <img src={imsLoader} alt="Loading Data" style={{ width: "25%" }} />
            </div>}
          </>
        )}
      </div>
    );

  }
}

export default KeyCongressLitGenAIRec;
